import {Location} from '@angular/common';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Subject, catchError, finalize, of, takeUntil} from 'rxjs';
import {PropostaCotacaoService} from 'src/app/api/module/erp/services/area-logada/proposta-cotacao/proposta.cotacao.service';
import {jwtAuthService} from 'src/app/api/module/erp/services/auth/jwtAuthService';
import {EntidadeConfig, EntidadeEnum} from 'src/app/api/module/erp/shared/enumerable/entidade.enum';
import {
  TipoProduto_E_OperadoraComponent,
  TipoProduto_E_OperadoraEnum,
} from 'src/app/api/module/erp/shared/enumerable/tipo-produto.enum';
import {ErrorLoggingService} from 'src/app/api/module/erp/shared/services/error-logs/error-logging.service';
import {SpinnerService} from 'src/app/api/module/erp/shared/services/spinner-service.service';
import {AutenticacaoPropostaService} from 'src/app/api/module/externo/services/proposta/autenticacao.proposta.service';

@Component({
  selector: 'app-documento-visualizar',
  templateUrl: './documento-visualizar.component.html',
  styleUrls: ['./documento-visualizar.component.scss'],
})
export class DocumentoVisualizarComponent implements OnInit, OnDestroy {
  idProposta!: string;
  dadosOperadoraDM: any;
  listaBeneficiarioDSSelecionados: any[] = [];
  euSou: 'colaborador' | 'beneficiario' = 'colaborador';
  heOdonto: boolean = false;
  entidades = {
    heUdemo: false,
    heUnimedFesp: false,
    heApase: false,
    heAbraWeb: false,
    heAbje: false,
    heAdservip: false,
    heAfuspen: false,
    heCpp: false,
    heCrosp: false,
    heSasp: false,
    heSindinutri: false,
    heTecnologos: false,
    heAastpj: false,

    heUniOdonto: false,
    heUnimedOdonto: false,
    heOdontoPrev: false,
  };
  tipoPoprosta: string = '';

  private destroy$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private _jwtAuthService: jwtAuthService,
    private router: Router,
    private location: Location,
    private _spinnerService: SpinnerService,
    private _errorLoggingService: ErrorLoggingService,
    private _propostaCotacaoService: PropostaCotacaoService,
    private toastr: ToastrService,
    private autenticacaoPropostaService: AutenticacaoPropostaService,
    private _router: Router,
  ) {}
  private readonly CHAVE_REDIRECIONAMENTO_COLAB = 'redirectAfterLoginColab';
  private readonly CHAVE_REDIRECIONAMENTO_BENEF = 'redirectAfterLoginBenef';

  ngOnInit(): void {
    const url = this.router.url;
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const idsString = params['ids'];

      if (idsString) {
        const idsArray = idsString.split(',');
        this.listaBeneficiarioDSSelecionados = idsArray;
      }
    });
    this.euSou = url.includes('beneficiario') ? 'beneficiario' : 'colaborador';
    const idProposta = this.route.snapshot.paramMap.get('idProposta');
    if (!idProposta) {
      this.router.navigate(['/']);
      return;
    }

    this.idProposta = idProposta;

    if (this.euSou === 'beneficiario') {
      this.autenticacaoPropostaService
        .verificarToken()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: autenticado => {
            if (autenticado) {
              this.carregarDadosProposta();
            } else {
              // Se não autenticado, salva a URL e redireciona
              localStorage.setItem(this.CHAVE_REDIRECIONAMENTO_BENEF, url);
              this.router.navigate(['/detalhes/proposta/autenticacao', idProposta]);
            }
          },
          error: () => {
            localStorage.setItem(this.CHAVE_REDIRECIONAMENTO_BENEF, url);
            this.router.navigate(['/detalhes/proposta/autenticacao', idProposta]);
          },
        });
      return;
    }

    if (!this._jwtAuthService.isUsuarioLogado()) {
      localStorage.setItem(this.CHAVE_REDIRECIONAMENTO_COLAB, url);
      this.router.navigate(['/login']);
      return;
    }

    this.carregarDadosProposta();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private carregarDadosProposta(): void {
    if (!this.idProposta) return;

    this.filtrarPropostaPorId();
  }
  async filtrarPropostaPorId(): Promise<void> {
    this.iniciarSpinner();
    const propostaId = this.route.snapshot.paramMap.get('idProposta') || this.idProposta;
    this._propostaCotacaoService
      .buscarDadosPropostaPorId(propostaId)
      .pipe(
        takeUntil(this.destroy$),
        catchError((error: any) => {
          this.toastr.error('Falha ao carregar documento com dados completos da proposta');
          this._errorLoggingService.logError('Buscar dados da proposta para o documento final', error, {
            contexto: 'DocumentoVisualizarComponent.filtrarPropostaPorId',
            data: { propostaId },
          });
          return of([]);
        }),
        finalize(() => {
          this.pararSpinner();
        }),
      )
      .subscribe((data: any) => {
        this.idProposta = data?.id;
        this.dadosOperadoraDM = data;
        this.carregarDadosDocumentos(this.dadosOperadoraDM);
      });
  }

  isOdonto(dadosOperadoraVM: any): boolean {
    return TipoProduto_E_OperadoraComponent.isOdonto(Number(dadosOperadoraVM?.productType));
  }

  carregarDadosDocumentos(data: any) {
    if (this.isOdonto(data)) {
      this.heOdonto = this.isOdonto(data);
      const dadosOperadora = TipoProduto_E_OperadoraComponent.getByCnpj(data.operatorCNPJ);
      this.tratarDadosTipoOperadoraOdonto(dadosOperadora.tipo);
    } else {
      this.tratarDocumentosSaude();
    }
  }

  private tratarDadosTipoOperadoraOdonto(tipoOperadora: any) {
    this.entidades.heOdontoPrev = false;
    this.entidades.heUniOdonto = false;
    this.entidades.heUnimedOdonto = false;
    switch (tipoOperadora) {
      case TipoProduto_E_OperadoraEnum.ODONTOPREV:
        this.entidades.heOdontoPrev = true;

        break;
      case TipoProduto_E_OperadoraEnum.UNIODONTO:
        this.entidades.heUniOdonto = true;
        break;
      case TipoProduto_E_OperadoraEnum.UNIMED_ODONTO:
        this.entidades.heUnimedOdonto = true;
        break;
    }
  }

  private tratarDocumentosSaude(): void {
    if (!this.dadosOperadoraDM) {
      return;
    }

    const entidadeConfig = EntidadeConfig.getConfig(this.dadosOperadoraDM?.branchCompanyName || '');
    this.entidades.heUdemo = entidadeConfig.tipo === EntidadeEnum.UDEMO;
    this.entidades.heUnimedFesp =
      entidadeConfig.tipo !== EntidadeEnum.UDEMO && entidadeConfig.tipo !== EntidadeEnum.APASE;
    this.entidades.heApase = entidadeConfig.tipo === EntidadeEnum.APASE;
    this.entidades.heAbraWeb = entidadeConfig.tipo === EntidadeEnum.ABRAWEB;
    this.entidades.heAbje = entidadeConfig.tipo === EntidadeEnum.ABJE;
    this.entidades.heAdservip = entidadeConfig.tipo === EntidadeEnum.ADSERVIP;
    this.entidades.heAfuspen = entidadeConfig.tipo === EntidadeEnum.AFUSPEN;
    this.entidades.heCpp = entidadeConfig.tipo === EntidadeEnum.CPP;
    this.entidades.heCrosp = entidadeConfig.tipo === EntidadeEnum.CROSP;
    this.entidades.heSasp = entidadeConfig.tipo === EntidadeEnum.SASP;
    this.entidades.heSindinutri = entidadeConfig.tipo === EntidadeEnum.SINDINUTRI;
    this.entidades.heTecnologos = entidadeConfig.tipo === EntidadeEnum.TECNOLOGOS;
    this.entidades.heAastpj = entidadeConfig.tipo === EntidadeEnum.AASTPJ;
  }

  voltar(): void {
    this.location.back();
  }

  iniciarSpinner() {
    this._spinnerService.show();
  }

  pararSpinner(ms?: number) {
    return new Promise(resolve => {
      setTimeout(() => {
        this._spinnerService.hide();
        resolve(true);
      }, ms);
    });
  }

  async imprimir() {
    try {
      // Adicionar classe para otimizar a impressão
      document.body.classList.add('gerando-pdf');

      // Adicionar regras CSS específicas para impressão
      const style = document.createElement('style');
      style.innerHTML = `
      @media print {
              /* FORÇAR ALTA QUALIDADE EM TODOS OS ELEMENTOS */
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
          color-adjust: exact !important;
        }




 html, body {
    background: #fff !important;
  }


  @page {
    size: A4;
    margin: 12mm;
  }

  /*   NÚMERO DA PÁGINA */

body::after {
  content: "Página " counter(page);
  position: fixed;
  bottom: 6mm;
  right: 10mm;
  font-size: 10px;
}


        #section-visualizar {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          background-color: white;
        }

        /* FORÇAR QUE CADA SECTION COMECE EM UMA NOVA PÁGINA */
        section {
           page-break-before: auto !important;
            break-before: auto !important;
        }

        /* A PRIMEIRA SECTION NÃO DEVE TER QUEBRA ANTES */
        section:first-of-type {
          page-break-before: auto !important;
          break-before: auto !important;
        }


section:last-of-type {
  page-break-after: auto;
}

 .nova-pagina {
    page-break-before: always;
    break-before: page;
  }

        /* Remover elementos desnecessários na impressão */
        .btn, .card.border-0.shadow-none.ocultar {
          display: none !important;
        }

        /* Garantir que cada imagem fique em uma página */

  app-lista-documentos-proposta .mb-4 {
    page-break-after: auto !important;
    break-after: auto !important;

    page-break-inside: avoid;
    break-inside: avoid;
  }


.image-wrapper {
    max-width: 45% !important;
  }

  app-lista-documentos-proposta .mb-4:last-child {
    page-break-after: avoid !important;
    break-after: avoid-page !important;
  }


        /* Ajustar imagens para caber na página */
        app-lista-documentos-proposta img {
          max-width: 100%;
          max-height: 90vh;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }

        app-lista-documentos-proposta pdf-viewer {
          width: 100%;
          height: 90vh;
          display: block;
        }


        /* Remover elementos desnecessários na impressão */
        .btn, .card.border-0.shadow-none.ocultar {
          display: none !important;
        }
      }
}

    `;
      document.head.appendChild(style);

      // Aguardar um momento para o CSS ser aplicado
      await new Promise(resolve => setTimeout(resolve, 500));

      // Abrir a janela de impressão
      window.print();
    } catch (error) {
      this.toastr.error('Não foi possível imprimir. Tente novamente.');
    } finally {
      // Remover a classe e o estilo após a impressão
      document.body.classList.remove('gerando-pdf');
      const styleElement = document.querySelector('style:last-child');
      if (styleElement) {
        styleElement.remove();
      }
      this.pararSpinner();
    }
  }

  recarregarRota() {
    const currentUrl = this._router.url;
    this._router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this._router.navigate([currentUrl]);
      setTimeout(() => {
        this.pararSpinner();
      }, 100);
    });
  }
}
